import { useLocation } from 'react-router-dom';

/**
 * Returns the current route (path + query), for use as a `fromRoute` target
 * in router state.
 */
export const useCurrentLocation = (): string => {
  const { pathname, search } = useLocation();
  return `${pathname}${search}`;
};
